var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-list"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8.24967 4.5835H6.41634C5.40382 4.5835 4.58301 5.40431 4.58301 6.41683V17.4168C4.58301 18.4294 5.40382 19.2502 6.41634 19.2502H15.583C16.5955 19.2502 17.4163 18.4294 17.4163 17.4168V6.41683C17.4163 5.40431 16.5955 4.5835 15.583 4.5835H13.7497",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8.25,
    y: 2.75,
    width: 5.5,
    height: 3.66667,
    rx: 1.83333,
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M8.24965 10.9998H8.25882",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M11.917 10.9998H13.7503",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M8.24965 14.6668H8.25882",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M11.917 14.6668H13.7503",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardList);
export default __webpack_public_path__ + "static/media/clipboard-list.8904c693dc07e12af8a65c1dff27f6f5.svg";
export { ForwardRef as ReactComponent };